import { createSelector } from 'reselect';
import mappings from './mappings';

export const getIndependentAmountInitialised = state => state.independentAmount.initialisedIndependentAmount;

export const getDefaultFilters = state => state.independentAmount.defaultFilters;

export const getFilterDefinitions = state => state.independentAmount.filterDefinitions;
export const getIndependentAmountLastUpdated = state => state.independentAmount.lastUpdatedIndependentAmount;
export const getDefaultSort = state => (
    state.independentAmount.gridSorting
);
export const getDateFrom = (state) => {
    if (state) {
        const filter = state.find(obj => obj.definition.id === 'runDate');
        if (filter && filter.value) {
            return filter.value.from;
        }
    }
    return null;
};

export const combinedColumnsSelector = createSelector(
    state => state.independentAmount.columnsForIndependentAmount,
    columns => columns.map(column => ({
        ...column,
        ...mappings.find(col => col.id === column.id)
    }))
);